module.exports = __webpack_public_path__ + "img/alert-red-triangle.3130df4b.svg";